import { Divider } from "antd";

function EvaluationSections({ section, isLastSection }: { section: any, isLastSection: boolean }) {
    return (
        <section>
            <header>
                <h5 className="uppercase text-[13px] font-semibold tracking-wide mt-6 mb-1">
                    {section?.title}
                </h5>
                <Divider className="m-0 border-gray-200" />
            </header>

            <ul className="mt-3">
                {section?.metrics?.map((metric: any, index: number) => {
                    const isLastQuestion = index === section?.metrics?.length - 1;

                    return (
                        <li key={index} className="mb-3">
                            <article className="flex justify-between items-start gap-4">
                                <div className="max-w-[90%]">
                                    <h6 className="font-normal mb-1.5 text-base leading-snug text-gray-900 break-words">
                                        {metric?.question}
                                    </h6>
                                    {metric?.answerSummary && (
                                        <p className="font-normal text-sm leading-relaxed text-gray-600 break-words">
                                            {metric?.answerSummary}
                                        </p>
                                    )}
                                </div>

                                <span className="text-xs font-semibold text-indigo-600 whitespace-nowrap">
                                    {metric?.rating}/5
                                </span>
                            </article>

                            {!(isLastSection && isLastQuestion) && (
                                <Divider className="my-3 border-gray-200" />
                            )}
                        </li>
                    );
                })}
            </ul>
        </section>
    );
};

export default EvaluationSections;
